<template>
  <b-modal
      :ref="name"
      :title="title"
      cancel-title="Close"
      ok-only
      size="md"
      @close="close"
      @ok="close"
  >
    <template #modal-header>
      <div class="w-100">
        <h4 class="float-left">{{ title }}: <small>{{game.gameId | shortId}}</small></h4>
      </div>
    </template>
   <div>
     <table class="table b-table table-striped table-hover border" >
       <thead class="thead-dark">
        <tr>
          <th>
            Place
          </th>
          <th>
            Nick
          </th>
          <th>
            Award
          </th>
        </tr>
       </thead>
       <tbody v-if="items">
        <tr v-for="(pl, index) in items" :key="index">
          <td>{{pl.finalClassificationPlace}}</td>
          <td>{{pl.nickName}}</td>
          <td>{{pl.award | numberFormat}}</td>
        </tr>
       </tbody>
     </table>

     <div class="spinner-wrapper" v-if="!items">
       <b-spinner></b-spinner>
     </div>

   </div>
    <template #modal-footer>
      <div class="w-100">
        <div class="buttons float-right">
          <b-button type="button" variant="secondary" @click="close">Close</b-button>
        </div>
      </div>
    </template>
  </b-modal>

</template>

<script>

import axios from "axios";

export default {
  props: {},
  data() {
    return {
      name: 'default-modal',
      title: '',
      busy: false,
      entry: null,
      game: null,
      items: null
    }
  },

  mounted: function () {
    this.$refs[this.name].show();
    this.getDetails();
  },
  methods: {
    getDetails() {
      const _that = this;
      axios.get(`/api/player/${this.$route.params.id}/game-history-item-details/${this.game.gameId}`)
      .then(data => {
        _that.items = data.data.players;
      })
    },
    close() {
      this.$refs[this.name].hide();
    },
    submit() {

    }
  }

}

</script>
